import { CrudPage } from '@restavo/crud';
import React from 'react';
import { useTransactionsPage } from 'src/features/transactions';

const Transactions = React.memo(
  ({ expenses, incomes, investments }: { expenses?: boolean; incomes?: boolean; investments?: boolean }) => {
    const { page } = useTransactionsPage({ expenses, incomes, investments });
    return <CrudPage {...page} />;
  }
);

export default Transactions;
